import { useState, useEffect } from 'react';

// Font utility classes (defined in index.css) that the animated text cycles through.
export const RANDOM_FONTS = [
  'rf-playfair', 'rf-anton', 'rf-bebas', 'rf-righteous', 'rf-monoton',
  'rf-lobster', 'rf-bungee', 'rf-pacifico', 'rf-orbitron', 'rf-oswald',
];

// Default delay (ms) between font swaps.
export const FONT_SWAP_INTERVAL_MS = 650;

const pickDifferentFont = (current) => {
  let next = current;
  while (next === current) {
    next = RANDOM_FONTS[Math.floor(Math.random() * RANDOM_FONTS.length)];
  }
  return next;
};

/**
 * Cycles through RANDOM_FONTS at a fixed interval, always returning a font
 * class different from the previous one. Returns the current font class name.
 */
export default function useRandomFont(intervalMs = FONT_SWAP_INTERVAL_MS) {
  const [fontClass, setFontClass] = useState(RANDOM_FONTS[0]);

  useEffect(() => {
    const timerId = setInterval(() => {
      setFontClass(pickDifferentFont);
    }, intervalMs);
    return () => clearInterval(timerId);
  }, [intervalMs]);

  return fontClass;
}
